// @flow

// import querystring from 'querystring';

// import type { OnEnter } from 'app/common/types';

const routes = {
  '/app/get-help': {
    fetch: () =>
      import(
        /* webpackChunkName: 'get-help-route' */ 'app/get-help/asyncRoute'
      ).then(module => module.default),
  },
  // TODO: Enable once we drop contact-us
  //
  // '/app/contact-us': {
  //   onEnter({
  //     routeTo,
  //     router: {
  //       next: { query },
  //     },
  //   }: OnEnter) {
  //     const qs = querystring.stringify(query);
  //     routeTo(`/app/get-help${qs ? `?${qs}` : ''}`);
  //   },
  // },
  // '/app/contact': {
  //   onEnter({
  //     routeTo,
  //     router: {
  //       next: { query },
  //     },
  //   }: OnEnter) {
  //     const qs = querystring.stringify(query);
  //     routeTo(`/app/get-help${qs ? `?${qs}` : ''}`);
  //   },
  // },
};

export default routes;
